import palette from "src/theme/palette";

export const SANKEY_COLORS = {
  PRIMARY: "#7C5CFC", // not yet part of palette
  PURPLE_LIGHT: "#A78BFA", // not yet part of palette
  TEAL: "#14B8A6", // not yet part of palette
  BLUE: "#3B82F6", // not yet part of palette
  LILAC: "#C084FC", // not yet part of palette
  GREY: palette.grey[400],
  LEAF: palette.grey[500]
};

export const SANKEY_NODE_OPACITY = { DIM: 0.15, DEFAULT: 0.85, HOVER: 1 };
export const SANKEY_LINK_OPACITY = { DIM: 0.1, DEFAULT: 0.3, HOVER: 0.4 };
export const SANKEY_CARD_DIM_OPACITY = 0.1;
export const SANKEY_HOVER_TRANSITION = "opacity 0.2s ease";

// spacing reserves room for the static card (38px) + 8px gap between stacked nodes
export const SANKEY_NODE_SPACING = 46;
export const SANKEY_NODE_THICKNESS = 36;
export const SANKEY_NODE_BORDER_RADIUS = 4;
export const SANKEY_MIN_NODE_HEIGHT_RATIO = 0.04;

export const SANKEY_CARD_GAP = 8;
export const SANKEY_CARD_HEIGHT = 38;
export const SANKEY_TOP_MARGIN = SANKEY_CARD_HEIGHT + SANKEY_CARD_GAP;
export const SANKEY_RIGHT_MARGIN = 150;
// minimum horizontal space per step so static cards fit without truncation; below it the chart scrolls
export const SANKEY_MIN_COLUMN_WIDTH = 220;

// per Figma: first-step node (486px) + card zone (46px) — nodes fill everything below the card zone
export const SANKEY_DEFAULT_HEIGHT = 532;
